import { Box, Skeleton } from "@mui/material";

export interface DataGridColumnWidth {
  width?: number | string;
  flex?: number;
  minWidth?: number;
}

interface DataGridTableSkeletonProps {
  height?: number | string;
  columnWidths?: DataGridColumnWidth[];
  rowCount?: number;
  showPagination?: boolean;
  iconColumnIndex?: number;
}

export default function DataGridTableSkeleton({
  height = 500,
  showPagination = true,
}: DataGridTableSkeletonProps) {
  const paginationHeight = showPagination ? 52 : 0;
  const bodyHeight =
    typeof height === "number"
      ? Math.max(height - paginationHeight - 16, 140)
      : `calc(${height} - ${paginationHeight + 16}px)`;

  return (
    <Box
      sx={{
        height,
        border: "1px solid #e0e0e0",
        borderRadius: 1,
        overflow: "hidden",
        bgcolor: "#fff",
      }}
    >
      <Box sx={{ px: 1.5, py: 1.5, height: bodyHeight }}>
        <Skeleton
          variant="rounded"
          animation="wave"
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: 1,
          }}
        />
      </Box>

      {showPagination && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            height: paginationHeight,
            px: 2,
            borderTop: "1px solid #e0e0e0",
            gap: 2,
          }}
        >
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="rounded" width={24} height={24} />
          <Skeleton variant="rounded" width={24} height={24} />
        </Box>
      )}
    </Box>
  );
}
